import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigServiceProvider} from '../../../core/services/config-service/config-service';
import {StorageServiceProvider} from '../../../core/services/storage-service/storage-service';

@Injectable()
export class KnowledgeServiceProvider {
  constructor(private http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {
  }

  load() {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('knowledge')).toPromise().then(response => {
        return this.storageService.setObject('knowledge', response).then(() => resolve()).catch((err) => reject(err));
      })
    });
  }

  getKnowledgeCategories() {
    return this.storageService.getObject('knowledge');
  }
}



// WEBPACK FOOTER //
// ./src/modules/knowledge/services/knowledge-service/knowledge-service.ts